<template lang='pug'>
section
  s-page-title(title='График ввода')
  v-card
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :hide-actions='true'
    )
      template(slot='items' slot-scope='props')
        tr
          td(data-label='Название') {{ props.item.name }}
          td(data-label='Адрес') {{ props.item.view_adr }}
          td(data-label='Дата ввода в эксплуатацию') {{ props.item.date_startup | date }}
          td(data-label='Дата выдачи ключей') {{ props.item.date_keys | date }}
</template>

<script>
import http from '@/http'
export default {
  data: () => ({
    list: [],
    isLoading: false,
    headers: [
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '20%',
      },
      {
        text: 'Адрес',
        align: 'left',
        value: 'view_adr',
        width: '20%',
      },
      {
        text: 'Дата ввода в эксплуатацию',
        align: 'left',
        value: 'date_startup',
        width: '20%',
      },
      {
        text: 'Дата выдачи ключей',
        align: 'left',
        value: 'date_keys',
        width: '20%',
      },
    ]
  }),

  async created() {
    this.isLoading = true

    try {
      this.list = (await http.get('partners/building-schedule')).data
    } catch(e) {
      this.$root.showSnack('Ошибка загрузки')
    }

    this.isLoading = false
  }
}
</script>
